import React from "react";

function CreateMiddleWare() {
  return <div>CreateMiddleWare</div>;
}

export default CreateMiddleWare;
